import { colors } from '@shared/tokens/colors.stylex';
import { FC } from 'react';

interface ArrowLeftIconProps {
  color?: string;
}

export const ArrowLeftIcon: FC<ArrowLeftIconProps> = ({ color = colors.accentIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35355 2.64645C7.54882 2.84171 7.54882 3.15829 7.35355 3.35355L3.20711 7.5H14C14.2761 7.5 14.5 7.72386 14.5 8C14.5 8.27614 14.2761 8.5 14 8.5H3.20711L7.35355 12.6464C7.54882 12.8417 7.54882 13.1583 7.35355 13.3536C7.15829 13.5488 6.84171 13.5488 6.64645 13.3536L1.64645 8.35355C1.45118 8.15829 1.45118 7.84171 1.64645 7.64645L6.64645 2.64645C6.84171 2.45118 7.15829 2.45118 7.35355 2.64645Z"
        fill={color}
      />
    </svg>
  );
};
